import { withInstall } from '@element-plus/utils/with-install'
import CheckTag from './src/index.vue'

export const ElCheckTag = withInstall(CheckTag)
export default ElCheckTag
